import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { crossScreenFontSize } from '../../../utils/styles';
import { FONT_SIZE_BIG } from '../../../constants';
import Media from '../../Media';

const Styled = styled.div`
  position: relative;
  overflow: hidden;

  &,
  * {
    height: 100%;
    width: 100%;
  }
`;

const StyledMedia = styled(Media)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
  
  img,
  video {
    width: 100%;
    object-fit: cover;
    font-family: 'object-fit: cover;';
    
    ${props =>
      !props.alternativeAnimation &&
      css`
        transition: transform 0.25s ease-out, opacity 0.15s ease-out;
        opacity: 0;
        will-change: transform;
      `}
  }

  ${props =>
    props.active &&
    css`
      img, video {
        transition: transform 0.5s ease-out 0.15s, opacity 0.25s ease-out 0.15s;
        ${!props.alternativeAnimation &&
          css`
            opacity: 1;
            transform: scale(1.1);
          `};
    `};
}
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  flex-direction: column;
  opacity: 0;
  will-change: opacity;

  ${props =>
    props.active &&
    css`
      transition: opacity 0.5s ease-out;
      opacity: 1;
    `};
`;

const TitleBase = styled.div`
  ${crossScreenFontSize(FONT_SIZE_BIG)};
  height: auto;
`;

const Title = styled(TitleBase)`
  color: #fff;
`;

const Subtitle = styled(TitleBase)`
  color: ${props => props.theme.colorMinor};
`;

class Slide extends React.Component {
  static propTypes = {
    media: PropTypes.object.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    active: PropTypes.bool,
  };

  render() {
    const { className, title, subtitle, media, active, alternativeAnimation, showBackground } = this.props;

    return (
      <Styled className={className}>
        <StyledMedia
          {...media}
          active={active}
          noPreview={!active}
          alternativeAnimation={alternativeAnimation}
          fullHeight
          noRatio
          showBackground={showBackground}
        />
        {title && (
          <Content active={active}>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
          </Content>
        )}
      </Styled>
    );
  }
}

export default Slide;



// WEBPACK FOOTER //
// ./src/components/Carousel/components/Slide.js